import { render, staticRenderFns } from "./replacementItem.vue?vue&type=template&id=40642a28&scoped=true&"
import script from "./replacementItem.vue?vue&type=script&lang=js&"
export * from "./replacementItem.vue?vue&type=script&lang=js&"
import style0 from "./replacementItem.vue?vue&type=style&index=0&id=40642a28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40642a28",
  null
  
)

export default component.exports